import React from 'react'

// class IFrameComponent extends React.PureComponent {
//     constructor(props) {
//         super(props);
//     }
//     state = {}
//     render() {
//         return (
//             <>
//                 <iframe
//                     key={Math.random()}
//                     src={this.props.iframeSrc}

//                     style={{ width: "100%", height: "100%" }}
//                 >
//                 </iframe>
//             </>
//         );
//     }
// }

// export default IFrameComponent;


const IFrameComponent = (props) => {

    return (
        <>
            <iframe
                key={Math.random()}
                src={props.iframeSrc}

                style={{ width: "100%", height: "100%" }}
            >
            </iframe>
        </>
    );
}
export default IFrameComponent;